import type { ForwardedRef } from "react";

export function setForwarderRef<T>(
  forwardedRef: ForwardedRef<T> | undefined,
  ref: T
) {
  if (forwardedRef) {
    if ("current" in forwardedRef) {
      forwardedRef.current = ref;
    } else {
      forwardedRef(ref);
    }
  }
}
